import { render, staticRenderFns } from "./PrimarySelect.vue?vue&type=template&id=57028bda&scoped=true&"
import script from "./PrimarySelect.vue?vue&type=script&lang=js&"
export * from "./PrimarySelect.vue?vue&type=script&lang=js&"
import style0 from "./PrimarySelect.vue?vue&type=style&index=0&id=57028bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57028bda",
  null
  
)

component.options.__file = "PrimarySelect.vue"
export default component.exports